import { FaUser, FaLock, FaEye, FaEyeSlash } from 'react-icons/fa';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext'; // Importar o contexto de autenticação
import './Login.css';
import URLManager from './URLManager';

const LoginPage = () => {

  
  const _url =URLManager.getBaseURL()

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false); // Estado para lembrar login
  const [showLoadingScreen, setShowLoadingScreen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false); // Estado para mostrar/ocultar senha
  const navigate = useNavigate(); // Hook para navegar
  const { login } = useAuth(); // Obter a função de login do contexto

  
  // Carregar email e senha do localStorage se o usuário escolheu "Lembrar"
  useEffect(() => {
    const savedUsername = localStorage.getItem('rememberedUsername');
    const savedPassword = localStorage.getItem('rememberedPassword');
    
    if (savedUsername && savedPassword) {
      setUsername(savedUsername);
      setPassword(savedPassword);
      setRememberMe(true); // Define como marcado se os dados foram carregados
    }
  }, []);

  // Login user
  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);

    const loginData = {
      email: username,
      password: password,
    };

    try {
      // Faz a requisição POST para o endpoint de login
      const response = await fetch(`${_url}/user/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: "application/json",
          
        },
        body: JSON.stringify(loginData),
      });

      if (response.ok) {
        // Login bem-sucedido
        const user = await response.json();
        console.log('Login realizado com sucesso:', user);
        
        // Salva os dados no sessionStorage
        sessionStorage.setItem("usuarioToken", user.token);
        sessionStorage.setItem("usuarioNome", user.name);
        sessionStorage.setItem("permissoes",JSON.stringify(user.permissoes));
        login(); // Chamar a função de login do contexto
        setShowLoadingScreen(true);
        setTimeout(() => {
          setShowLoadingScreen(false);
        navigate('/dashboard');
        }, 5000);

        if (rememberMe) {
          // Se a caixa "Lembrar" estiver marcada, salvar no localStorage
          localStorage.setItem('rememberedUsername', username);
          localStorage.setItem('rememberedPassword', password);
        } else {
          // Se desmarcado, remover dados do localStorage
          localStorage.removeItem('rememberedUsername');
          localStorage.removeItem('rememberedPassword');
        }
      } else {
        // Tratamento de erro
        const errorData = await response.json();
        console.log('Erro no login', errorData);
        alert('Falha no login. Verifique suas credenciais.');
      }
    } catch (error) {
      console.error('Erro de rede:', error);
      alert('Erro de rede. Tente novamente mais tarde.');
    } finally {
      setLoading(false); // Desativar carregamento
    }
  };

  return (
    <div className='containerLogin-log'>
      {showLoadingScreen ? (
        <div className="loading-screenteste-ok">
          <h2>Carregando...</h2>
        </div>
      ) : (
      <form onSubmit={handleSubmit}>
        <h1>Acesse o sistema</h1>
        <div className='input-field-b'>
          <input
            type='email'
            placeholder='E-mail'
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            disabled={loading}
          />
          <FaUser className='icon icon-left' />
        </div>
        <div className='input-field-b password-input-wrapper'>
          <input
            type={showPassword ? 'text' : 'password'}
            placeholder='Senha'
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            disabled={loading}
          />
          <FaLock className='icon icon-left' />
          <span
            className='icon icon-right'
            onClick={() => !loading && setShowPassword(!showPassword)}
            style={{ cursor: loading ? 'not-allowed' : 'pointer', opacity: loading ? 0.5 : 1 }}
          >
            {showPassword ? <FaEyeSlash /> : <FaEye />}
          </span>
        </div>
        <div className='recall-forget-b'>
          <label>
            <input
              type='checkbox'
              checked={rememberMe}
              onChange={() => setRememberMe(!rememberMe)}
              disabled={loading}
            />
            Lembrar
          </label>
        </div>
        <button type='submit' disabled={loading}>
          {loading ? 'Carregando...' : 'Entrar'}
        </button>
      </form>
      )}
    </div>
  );
};

export default LoginPage;
